/*
 * @Author: your name
 * @Date: 2021-03-18 11:55:12
 * @LastEditTime: 2021-08-17 09:17:01
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \ycfsite-vue\src\vuex\store.js
 */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
    count: 0,
    ImgServer:'https://smis.cn',
    ImgServer:'https://smis.cn/SmisSaasServer',
    // ImgServer:'http://192.168.192.56',
    isLogin:false,
    logText:'登录',
    logPath:'/Login',
    MenuName:'Login',
    token:localStorage.getItem("vc")
}
const mutations = {
     toLogInState(state,text){
          state.isLogin = true;
          state.logText = text;
          state.logPath = '/User';
          state.MenuName = 'User';
          state.token = localStorage.getItem("vc");
          return state
     },
     toLogoutState(state,text) {
          state.isLogin = false;
          state.logText = text;
          state.logPath = '/Login';
          state.MenuName = 'Login';
          state.token = null;
         return state
     }
 }
export default new Vuex.Store({
    state,
    mutations
})



// WEBPACK FOOTER //
// ./src/vuex/store.js